import PictureListSing from '@/components/PictureList/PictureListSing'
export default {
  components: {PictureListSing},
  data() {
    function validatePhoneOrTel(rule,value,callback) {
      let regex = /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/;

      if (value != null && !regex.test(value)) {
        callback(new Error("请输入正确的电话号码"));
      } else {
        callback();
      }
    }
    return {
      limitNum:1,
      picType:'img',
      optionsBooler:[
        {label:'是',value:true},{label:'否',value:false}
      ],
      form: {
        F_Id:'',
        F_CompanyName:'',//企业名称
        F_BusinessLicense:'',//社会统一信用代码
        F_Address:'',//联系地址
        F_JuridicalPersonName:'',//法人姓名
        F_JuridicalPersonIDNo:'',//法人身份证号
        F_JuridicalPersonTel:'',//法人手机号
        F_AccountBank:'',//开户银行
        F_Account:'',//开户银行账号
        F_IsAuthorize:'',//授权方式（true是 false否）
        F_YYZZImg_UrlBefore:[],//营业执照图片地址
        F_YYZZImg_Url:'',//营业执照图片地址
        F_FRSFZImg_UrlBefore:[],//法人身份证图片地址
        F_FRSFZImg_Url:'',//法人身份证图片地址
        F_YYKHXKImg_UrlBefore:[],//银行开户许可证图片地址
        F_YYKHXKImg_Url:'',//银行开户许可证图片地址
        F_AuthorizeImg_UrlBefore:[],//授权证明图片（授权方式为是时显示并必填）
        F_AuthorizeImg_Url:'',//授权证明图片（授权方式为是时显示并必填）
        F_AuthorizeName:'',//授权人姓名（授权方式为是时显示并必填）
        F_AuthorizeIDNo:'',//授权人身份证号（授权方式为是时显示并必填）
        F_AuthorizeSFZImg_UrlBefore:[],//授权人身份证图片（授权方式为是时显示并必填）
        F_AuthorizeSFZImg_Url:'',//授权人身份证图片（授权方式为是时显示并必填）
        F_PaymentAttach_UrlBefore:'',//凭证
        F_PaymentAttach_Url:'',//凭证
        F_AuthorizePhone:'',//授权人联系电话（授权方式为是时显示并必填）
        F_AuthorizeAddress:'',//授权人联系电话（授权方式为是时显示并必填）
        F_FaceImg_Url:'',//人脸识别图片
      },
      url: {
        GetCurrentAgentAuthentication: SZH.assets.api + '/Custom/GetCurrentAgentAuthenticationUp',
        SaveAgentCenterAuthentication: SZH.assets.api + '/Custom/SaveAgentCenterAuthenticationUp',//运营认证接口
        GetCompanyPaymentData: SZH.assets.api + '/Custom/GetCompanyPaymentData',
      },
      rules: {
        F_CompanyName: [
          {required: true,message: "请输入企业名称",trigger: "blur"},
          {max: 20,message: "长度不能超过 20 个字符",trigger: "blur"},
        ],
        F_BusinessLicense: [
          {required: true,message: "请输入社会统一信用代码",trigger: "blur"},
        ],
        F_FaceImg_Url: [
          {required: true,message: "请进行人脸识别",trigger: "blur"},
        ],
        F_Address: [
          {required: true,message: "请输入联系地址",trigger: "blur"},
        ],
        F_AuthorizeAddress: [
          {required: true,message: "请输入授权人联系地址",trigger: "blur"},
        ],
        F_JuridicalPersonName: [
          {required: true,message: "请输入法人姓名",trigger: "blur"},
        ],
        F_JuridicalPersonIDNo: [
          {required: true,message: "请输入法人身份证号",trigger: "blur"},
          // {
          //   validator: validateBusinessLicense,
          //   trigger: 'blur'
          // }
        ],
        F_JuridicalPersonTel: [
          {required: true,message: "请输入法人手机号",trigger: "blur"},
          {
            validator: validatePhoneOrTel,
            trigger: "blur",
          },
        ],
        F_AccountBank: [
          {required: true,message: "请输入开户银行",trigger: "blur"},
        ],
        F_Account: [
          {required: true,message: "请输入开户银行账号",trigger: "blur"},
        ],
        F_IsAuthorize: [
          {
            required: true,
            message: "请选择授权方式",
            trigger: "change",
          }
        ],
        F_YYZZImg_UrlBefore: [
          {required: true,message: "请选择营业执照图片",trigger: "blur"},
        ],
        F_PaymentAttach_UrlBefore: [
          {required: true,message: "请选择付款凭证",trigger: "blur"},
        ],
        F_FRSFZImg_UrlBefore: [
          {
            required:true,
            message:"请上传法人身份证!",
            trigger:"blur"
          }
        ],
        F_YYKHXKImg_UrlBefore: [
          {
            required:false,
            message:"请上传银行开户许可证!",
            trigger:"blur"
          }
        ],

        F_AuthorizeImg_UrlBefore: [
          {
            required: true,
            message: "请上传授权证明图片",
            trigger: "blur",
          },
        ],
        F_AuthorizeSFZImg_UrlBefore: [
          {
            required: true,
            message: "请上传授权人身份证图片",
            trigger: "blur",
          },
        ],
        F_AuthorizeName: [
          {
            required: true,
            message: "请输入授权人姓名",
            trigger: "blur",
          },
        ],
        F_AuthorizeIDNo: [
          {
            required: true,
            message: "请输入授权人身份证号",
            trigger: "blur",
          },
        ],
        F_AuthorizePhone: [
          {
            required: true,
            message: "请输入授权人电话",
            trigger: "blur",
          },
          {
            validator: validatePhoneOrTel,
            trigger: "blur",
          },
        ]
      },
      info:{
        ValidCode:'',
        agentData:{}
      },
      yyzxVisible:false,
      yyzxVisiblePerson:false,
      dialogFormVisible:false,
      loadingFull:false,
      dialogVisibleImg:false,
      dialogImageUrl:'',
      dialogVisibleImg1:false,
      dialogImageUrl1:'',
      com:{
        F_CompanyName:'',
        F_AccountBank:'',
        F_Account:'',
        F_FilePath:'',
      }
    }
  },
  methods: {
    showImg(url){
      let self = this;
      if(!url){
        return
      }
      self.dialogVisibleImg = true;
      self.dialogImageUrl = SZH.assets.image +'/' + url;
    },
    showImg1(url){
      let self = this;
      if(!url){
        return
      }
      self.dialogVisibleImg1 = true;
      self.dialogImageUrl1 = SZH.assets.image +'/' + url;
    },
    reSubmit(){
      let self = this;
      if(self.info.ValidCode == 'agentCenter'){
        self.yyzxVisible = true;
      }else{
        self.yyzxVisiblePerson = true;
      }
      self.onEdit();
    },
    onEdit(){
      let self = this;
      self.loadingFull = true;
      self.$http.post(self.url.GetCurrentAgentAuthentication,{})
        .then(result => {
          if (result.state == true) {
            if(result.data.ValidCode == 'agentCenter'){
              for(let i in self.form){
                self.form[i] = result.data.agentData[i];
                if(i == 'F_YYZZImg_Url'){
                  self.form.F_YYZZImg_UrlBefore = [{Url:result.data.agentData[i]}]
                }
                if(i == 'F_FRSFZImg_Url'){
                  self.form.F_FRSFZImg_UrlBefore = [{Url:result.data.agentData[i]}]
                }
                if(i == 'F_YYKHXKImg_Url' && result.data.agentData[i]){
                  self.form.F_YYKHXKImg_UrlBefore = [{Url:result.data.agentData[i]}]
                }
                if(i == 'F_PaymentAttach_Url'){
                  self.form.F_PaymentAttach_UrlBefore = [{Url:result.data.agentData[i]}]
                }
                if(i == 'F_AuthorizeSFZImg_Url' && result.data.agentData[i]){
                  self.form.F_AuthorizeSFZImg_UrlBefore = [{Url:result.data.agentData[i]}]
                }
                if(i == 'F_AuthorizeImg_Url' && result.data.agentData[i]){
                  self.form.F_AuthorizeImg_UrlBefore = [{Url:result.data.agentData[i]}]
                }
              }
            }
          } else {
            self.$message.error(result.message);
          }
          self.loadingFull = false;
        }, () => {
          self.loadingFull = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    registerYY(){
      let self = this;
      self.yyzxVisible = true;
    },

    handleDialogOpen(){
      this.$nextTick(()=>{
        this.$refs['formYY'].resetFields();
        this.form.F_YYZZImg_UrlBefore = [];
        this.form.F_FRSFZImg_UrlBefore = [];
        this.form.F_YYKHXKImg_UrlBefore = [];
        this.form.F_PaymentAttach_UrlBefore = [];
        this.form.F_AuthorizeSFZImg_UrlBefore = [];
        this.form.F_AuthorizeImg_UrlBefore = [];
      });
    },
    getImgUrl(url){
      if(url){
        return SZH.assets.image +'/' + url
      }else{
        return ''
      }
    },
    saveOperations(){
      let self = this;
      self.$refs['formYY'].validate((valid) => {
        if (valid) {
          self.form.F_YYZZImg_Url = self.form.F_YYZZImg_UrlBefore[0].Url;
          self.form.F_FRSFZImg_Url = self.form.F_FRSFZImg_UrlBefore[0].Url;
          // self.form.F_YYKHXKImg_Url = self.form.F_YYKHXKImg_UrlBefore[0].Url;
          self.form.F_YYKHXKImg_Url = (self.form.F_YYKHXKImg_UrlBefore && self.form.F_YYKHXKImg_UrlBefore.length>0)?self.form.F_YYKHXKImg_UrlBefore[0].Url:'';
          self.form.F_PaymentAttach_Url = self.form.F_PaymentAttach_UrlBefore[0].Url;
          self.form.F_AuthorizeImg_Url = (self.form.F_AuthorizeImg_UrlBefore && self.form.F_AuthorizeImg_UrlBefore.length>0)?self.form.F_AuthorizeImg_UrlBefore[0].Url:'';
          self.form.F_AuthorizeSFZImg_Url = (self.form.F_AuthorizeSFZImg_UrlBefore && self.form.F_AuthorizeSFZImg_UrlBefore.length>0)?self.form.F_AuthorizeSFZImg_UrlBefore[0].Url:'';
          self.loadingFull = true;
          self.$http.post(self.url.SaveAgentCenterAuthentication,self.form)
            .then(result => {
              if (result.state == true) {
                self.$message.success('保存成功');
                self.yyzxVisible = false;
                self.getInfo();
              } else {
                self.$message.error(result.message);
              }
              self.loadingFull = false;
            }, () => {
              self.loadingFull = false;
              // 请求失败
              self.$message.error('登录失败，请检查您的网络是否可用。');
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    getInfo(){
      let self = this;
      self.loading = true;
      self.$http.post(self.url.GetCurrentAgentAuthentication,{})
        .then(result => {
          if (result.state == true) {
            self.info = result.data;
          } else {
            self.info = {};
            self.$message.error(result.message);
          }
          self.loading = false;
        }, () => {
          self.loading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    getComInfo(){
      let self = this;
      self.loading = true;
      self.$http.post(self.url.GetCompanyPaymentData,{})
        .then(result => {
          if (result.state == true) {
            self.com = result.data;
          } else {
            self.com = {};
            self.$message.error(result.message);
          }
          self.loading = false;
        }, () => {
          self.loading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
  },
  computed: {},

  mounted() {
    this.getInfo();
    this.getComInfo();
  }
}



// WEBPACK FOOTER //
// ./src/views/Me/MemberUp/MemberUp.js